import { render, staticRenderFns } from "./LoanSupplierSelector.vue?vue&type=template&id=2870b906&"
import script from "./LoanSupplierSelector.vue?vue&type=script&lang=js&"
export * from "./LoanSupplierSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports